import React from 'react';
import AixueFooter from '@/components/AixueFooter/index';
import styles from './index.module.scss';
import Screen1 from './Screen1';
import Screen2 from './Screen2';

export default function AixueJoin() {
  return (
    <div className={`${styles.container} aixue-join-scroll`}>
      <Screen1 />
      <Screen2 />
      <div className={styles['footer-snap']}>
        <AixueFooter />
      </div>
    </div>
  );
}


